// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-module__tabs___CokqF","tab":"tabs-module__tab___u4z0O","icon":"tabs-module__icon___A6AXN","active":"tabs-module__active___faKSM"};